import 'lumen/assets/tailwind.css';
import '@mylighthouse/prism-ember/global-styles.css';
import 'frontend-utils/app/styles/frontend-utils/index.css';
import 'password-form/app/styles/password-form/index.css';
import 'lumen/assets/app.css';
import 'core-js/stable';
import 'decorator-transforms/globals';
// Polyfill intl plural rules for older safari/firefox versions: https://formatjs.io/docs/polyfills/intl-pluralrules/
import '@formatjs/intl-getcanonicallocales/polyfill.js';
import '@formatjs/intl-locale/polyfill.js';
import '@formatjs/intl-pluralrules/polyfill.js';
import '@formatjs/intl-pluralrules/locale-data/de.js';
import '@formatjs/intl-pluralrules/locale-data/en.js';
import '@formatjs/intl-pluralrules/locale-data/es.js';
import '@formatjs/intl-pluralrules/locale-data/fr.js';
import '@formatjs/intl-pluralrules/locale-data/it.js';
import '@formatjs/intl-pluralrules/locale-data/ja.js';
import '@formatjs/intl-pluralrules/locale-data/nl.js';
import '@formatjs/intl-pluralrules/locale-data/pt.js';
import '@formatjs/intl-pluralrules/locale-data/zh.js';

import Application from '@ember/application';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';
import { importSync, isDevelopingApp, macroCondition } from '@embroider/macros';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import { initializeErrorTracking } from 'frontend-utils/services/error-tracking';
import { customizeEmberInflector } from 'frontend-utils/utils/ember-data';
import config from 'lumen/config/environment';

if (macroCondition(isDevelopingApp())) {
  importSync('./deprecation-workflow');
}

initializeErrorTracking({
  ...config['@sentry/ember'].sentry,
  ignoreErrors: [/^Wrong api key or paused project$/],
});

customizeEmberInflector();

export default class App extends Application {
  inspector = setupInspector(this);
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
